
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import MediaHome from "../pages/media/page";
import ArticleList from "../pages/media/articles/page";
import ArticleDetail from "../pages/media/article-detail/page";
import ArticlePost from "../pages/media/post-article/page";
import Contact from "../pages/contact/page";
import AdminLogin from "../pages/admin/login/page";
import AdminDashboard from "../pages/admin/dashboard/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/media",
    element: <MediaHome />,
  },
  {
    path: "/media/articles",
    element: <ArticleList />,
  },
  {
    path: "/media/articles/:id",
    element: <ArticleDetail />,
  },
  {
    path: "/media/post",
    element: <ArticlePost />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/admin/login",
    element: <AdminLogin />,
  },
  {
    path: "/admin/dashboard",
    element: <AdminDashboard />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
